export const TOGGLE_NAV = 'TOGGLE_NAV';
export function toggleNav(level) {
  return {
    type: TOGGLE_NAV,
    level,
  };
}

export const ACTIVATE_NAV = 'ACTIVATE_NAV';
export function activateNav(level) {
  return {
    type: ACTIVATE_NAV,
    level,
  };
}

export const DEACTIVATE_NAV = 'DEACTIVATE_NAV';
export function deactivateNav(level) {
  return {
    type: DEACTIVATE_NAV,
    level,
  };
}
